import { useState } from "react";
import { IoMdLink } from "react-icons/io";

import { cn } from "~/utils/fontsConfig";
import { Input } from "~/components/v4/shadcn/Input";
import { Label } from "~/components/v3/shadcn/Label";
import Modal from "~/components/v3/themed/Modal";
import { CgOrganisation } from "react-icons/cg";
import { CustomizableLayout } from "~/types/CustomizableLayout";

export const OrganizationModal = ({
    children,
    customization,
}: {
    children: React.ReactNode;
    customization?: CustomizableLayout;
}) => {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <div className="flex w-full flex-col gap-2">
            <Label
                className={cn(
                    "text-sm font-[300] text-v3-N300",
                    customization?.inputLabelClassName,
                )}
            >
                Organization Info
            </Label>

            <Input
                value="Use Organization Info"
                placeholder="Add onsite location"
                className={cn(
                    "w-full cursor-pointer text-v3-N300",
                    isOpen && "border border-v3-clover",
                    customization?.inputClassName,
                )}
                onClick={() => setIsOpen(true)}
                suffixComponent={
                    <CgOrganisation
                        className={cn(
                            "h-4 w-4 text-v3-N300",
                            customization?.inputLabelClassName,
                        )}
                    />
                }
                readOnly
            />

            <Modal
                open={isOpen}
                onOpenChange={() => setIsOpen(false)}
                title="Organization Info"
                description=""
                icon={
                    <CgOrganisation
                        className={cn(
                            "h-4 w-4",
                            customization?.inputLabelClassName,
                        )}
                    />
                }
                className={cn(
                    "z-[5000] max-w-[400px]",
                    customization?.mainCardClassName,
                )}
                overlayClassName="z-[5000]"
            >
                {children}
            </Modal>
        </div>
    );
};
